/* SlideFoot — interacciones (sin librerías) */
(function () {
  if (window.__sfIniciado) return;
  window.__sfIniciado = true;
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COLORES = ['#ff5fa8', '#ffd43b', '#4cc9f0', '#c8ff3d', '#a66bff', '#1fd15e'];

  function dinero(centavos) {
    var fmt = (window.Shopify && window.sfFormatoDinero) || '${{amount}}';
    var v = (centavos / 100).toFixed(2).replace(/\.00$/, '');
    var partes = v.split('.');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, partes.join('.'));
  }
  window.sfDinero = dinero;

  /* Aparición al hacer scroll */
  function initReveal() {
    var els = document.querySelectorAll('.sf-reveal');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('sf-visible'); }); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('sf-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Grajeas flotantes decorativas */
  function initGrajeas() {
    document.querySelectorAll('.sf-grajeas[data-n]').forEach(function (c) {
      var n = parseInt(c.dataset.n, 10) || 0;
      for (var i = 0; i < n; i++) {
        var g = document.createElement('i');
        if (i % 3 === 0) g.className = 'sf-bolita';
        g.style.left = (Math.random() * 96) + '%';
        g.style.top = (Math.random() * 90) + '%';
        g.style.setProperty('--r', (Math.random() * 180 - 90) + 'deg');
        g.style.animationDelay = (-Math.random() * 5) + 's';
        g.style.animationDuration = (4 + Math.random() * 3) + 's';
        c.appendChild(g);
      }
    });
  }

  /* Confeti de dulces */
  function confeti(x, y) {
    if (reducido) return;
    for (var i = 0; i < 26; i++) {
      var p = document.createElement('span');
      p.className = 'sf-confeti';
      p.style.background = COLORES[i % COLORES.length];
      p.style.left = x + 'px'; p.style.top = y + 'px';
      document.body.appendChild(p);
      var ang = Math.random() * Math.PI * 2, dist = 80 + Math.random() * 160;
      p.animate([
        { transform: 'translate(0,0) rotate(0deg) scale(1)', opacity: 1 },
        { transform: 'translate(' + Math.cos(ang) * dist + 'px,' + (Math.sin(ang) * dist - 60) + 'px) rotate(' + (Math.random() * 720) + 'deg) scale(.6)', opacity: 1, offset: .7 },
        { transform: 'translate(' + Math.cos(ang) * dist * 1.1 + 'px,' + (Math.sin(ang) * dist + 120) + 'px) rotate(' + (Math.random() * 900) + 'deg) scale(.4)', opacity: 0 }
      ], { duration: 1100 + Math.random() * 500, easing: 'cubic-bezier(.2,.8,.3,1)' }).onfinish = function () { this.effect.target.remove(); };
    }
  }
  window.sfConfeti = confeti;

  /* Barra flotante: aparece al bajar */
  function initFlotante() {
    var f = document.querySelector('.sf-flotante');
    if (!f) return;
    var umbral = parseInt(f.dataset.umbral || '500', 10);
    function mirar() { f.classList.toggle('sf-ver', window.scrollY > umbral && !document.body.classList.contains('sf-toast-abierto')); }
    window.addEventListener('scroll', mirar, { passive: true });
    mirar();
  }

  /* Contador del carrito de la cabecera */
  function actualizarBurbuja(cuenta) {
    var icono = document.getElementById('cart-icon-bubble');
    if (!icono) return;
    var burbuja = icono.querySelector('.cart-count-bubble');
    if (!burbuja) {
      burbuja = document.createElement('div');
      burbuja.className = 'cart-count-bubble';
      icono.appendChild(burbuja);
    }
    burbuja.innerHTML = '<span aria-hidden="true">' + cuenta + '</span><span class="visually-hidden">' + cuenta + ' artículos</span>';
    icono.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.4) rotate(-10deg)' }, { transform: 'scale(1)' }], { duration: 500 });
  }

  /* Aviso tras agregar (con barra hacia la promo) */
  function mostrarToast(item, carrito, cfg) {
    var t = document.querySelector('.sf-toast');
    if (!t) return;
    var piezas = carrito.item_count;
    var resto = piezas % 3;
    var msg, pct;
    if (piezas >= 3 && resto === 0) { msg = cfg.msg3; pct = 100; }
    else if (piezas % 3 === 2) { msg = cfg.msg2; pct = 66; }
    else { msg = cfg.msg1; pct = 33; }
    t.querySelector('.sf-toast__nombre').textContent = item.product_title;
    t.querySelector('.sf-toast__var').textContent = item.variant_title ? 'Talla / opción: ' + item.variant_title : '';
    var img = t.querySelector('img');
    if (item.image) { img.src = item.image; img.hidden = false; } else img.hidden = true;
    t.querySelector('.sf-toast__msg').innerHTML = msg.replace('[piezas]', piezas);
    var barra = t.querySelector('.sf-toast__barra i');
    barra.style.width = '0';
    t.classList.add('sf-ver');
    document.body.classList.add('sf-toast-abierto');
    var fl = document.querySelector('.sf-flotante'); if (fl) fl.classList.remove('sf-ver');
    requestAnimationFrame(function () { setTimeout(function () { barra.style.width = pct + '%'; }, 120); });
  }
  function initToast() {
    var t = document.querySelector('.sf-toast');
    if (!t) return;
    t.querySelectorAll('[data-sf-cerrar]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); t.classList.remove('sf-ver'); document.body.classList.remove('sf-toast-abierto'); });
    });
  }

  /* Carrito lateral */
  function agregarAlCarrito(items) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (res) { return res.json().then(function (j) { if (!res.ok) throw j; return j; }); });
  }
  function abrirCarrito(res) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !res.sections || typeof drawer.renderContents !== 'function') return false;
    drawer.classList.remove('is-empty');
    drawer.renderContents(res);
    return true;
  }
  function initSugerencias() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sf-sug-agregar]');
      if (!b) return;
      var sel = b.parentElement.querySelector('[data-sf-sug-variante]');
      if (!sel || !sel.value) return;
      b.setAttribute('aria-busy', 'true');
      var r = b.getBoundingClientRect();
      agregarAlCarrito([{ id: parseInt(sel.value, 10), quantity: 1 }])
        .then(function (res) { confeti(r.left + r.width / 2, r.top); abrirCarrito(res); })
        .catch(function (err) { b.removeAttribute('aria-busy'); var box = document.getElementById('CartDrawer-CartErrors'); if (box) box.textContent = (err && (err.description || err.message)) || 'No se pudo agregar.'; });
    });
  }

  /* Cuenta regresiva de la promoción (fecha fija con zona horaria: igual en cualquier dispositivo) */
  function initCuenta() {
    var relojes = Array.prototype.slice.call(document.querySelectorAll('[data-sf-cuenta]'));
    if (!relojes.length) return;
    var fin = Date.parse(relojes[0].getAttribute('data-sf-cuenta'));
    if (isNaN(fin)) return;
    var dos = function (n) { return n < 10 ? '0' + n : String(n); };
    function terminar() {
      document.querySelectorAll('[data-sf-promo]').forEach(function (el) { el.hidden = true; });
      clearInterval(t);
    }
    function pintar() {
      var falta = fin - Date.now();
      if (falta <= 0) { terminar(); return; }
      var s = Math.floor(falta / 1000);
      var v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      relojes.forEach(function (r) {
        r.querySelectorAll('[data-u]').forEach(function (b) { var n = v[b.getAttribute('data-u')]; var txt = b.getAttribute('data-u') === 'd' ? String(n) : dos(n); if (b.textContent !== txt) b.textContent = txt; });
      });
    }
    var t = setInterval(pintar, 1000);
    pintar();
  }

  /* Botón volver arriba */
  function initArriba() {
    var b = document.querySelector('[data-sf-arriba]');
    if (!b) return;
    function mirar() { var v = window.scrollY > 900; b.classList.toggle('sf-ver', v); b.tabIndex = v ? 0 : -1; }
    window.addEventListener('scroll', mirar, { passive: true }); mirar();
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reducido ? 'auto' : 'smooth' }); });
  }

  /* Pop-up de bienvenida */
  function initPopup() {
    var pop = document.querySelector('[data-sf-pop]');
    if (!pop) return;
    var KEY = 'sf-popup-visto', SUS = 'sf-popup-suscrito';
    var dias = parseInt(pop.dataset.dias, 10) || 7;
    var codigo = pop.dataset.codigo || '';
    var ok = pop.querySelector('[data-sf-pop-ok]');
    var leer = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
    var guardar = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };
    var ultimoFoco = null;
    function abrir() {
      ultimoFoco = document.activeElement;
      pop.hidden = false; document.documentElement.style.overflow = 'hidden';
      var f = pop.querySelector(window.matchMedia('(min-width: 641px)').matches ? 'input[type=email], [data-sf-pop-ok] button' : '.sf-pop__x'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 50);
    }
    function cerrar() {
      pop.hidden = true; document.documentElement.style.overflow = '';
      if (!ok) guardar(KEY, String(Date.now()));
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    }
    pop.querySelectorAll('[data-sf-pop-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) cerrar(); });

    /* Suscripción exitosa: aplicar el código y mostrar confirmación */
    if (ok) {
      guardar(SUS, '1');
      if (codigo) fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'discount/' + encodeURIComponent(codigo), { credentials: 'same-origin' }).catch(function () {});
      abrir(); return;
    }
    if (pop.querySelector('.sf-pop__error')) { abrir(); return; }
    if (pop.hasAttribute('data-editor')) return;
    if (leer(SUS)) return;
    var visto = parseInt(leer(KEY), 10);
    if (visto && Date.now() - visto < dias * 864e5) return;
    setTimeout(function () { if (pop.hidden) abrir(); }, (parseInt(pop.dataset.retraso, 10) || 6) * 1000);
  }

  /* Página de producto */
  function initProducto() {
    var raiz = document.querySelector('[data-sf-producto]');
    if (!raiz) return;
    var datos = JSON.parse(raiz.querySelector('[data-sf-variantes]').textContent);
    var cfg = JSON.parse(raiz.querySelector('[data-sf-config]').textContent);
    var form = raiz.querySelector('form[action*="/cart/add"]');
    var inputId = form.querySelector('input[name="id"]');
    var precioEl = raiz.querySelector('[data-sf-precio]');
    var compEl = raiz.querySelector('[data-sf-comparar]');
    var boton = raiz.querySelector('[data-sf-agregar]');
    var textoBoton = boton.querySelector('span');
    var cant = raiz.querySelector('[data-sf-cantidad]');
    var principal = raiz.querySelector('[data-sf-principal]');
    var minis = Array.prototype.slice.call(raiz.querySelectorAll('[data-sf-mini]'));
    var idx = 0;

    function visibles() { return minis.filter(function (m) { return !m.hidden; }); }
    function mostrar(mini) {
      if (!mini || !principal) return;
      minis.forEach(function (m) { m.classList.remove('sf-activa'); });
      mini.classList.add('sf-activa');
      idx = visibles().indexOf(mini);
      principal.classList.add('sf-cambia');
      setTimeout(function () {
        if (mini.dataset.srcset) principal.srcset = mini.dataset.srcset; else principal.removeAttribute('srcset'); principal.src = mini.dataset.grande; principal.alt = mini.dataset.alt || '';
        principal.onload = function () { principal.classList.remove('sf-cambia'); };
        setTimeout(function () { principal.classList.remove('sf-cambia'); }, 400);
      }, 180);
      var tira = mini.parentElement;
      if (tira) tira.scrollTo({ left: mini.offsetLeft - tira.clientWidth / 2 + mini.clientWidth / 2, behavior: reducido ? 'auto' : 'smooth' });
    }
    minis.forEach(function (m) { m.addEventListener('click', function () { mostrar(m); }); });
    raiz.querySelectorAll('[data-sf-flecha]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = visibles(); if (!v.length) return;
        idx = (idx + parseInt(b.dataset.sfFlecha, 10) + v.length) % v.length;
        mostrar(v[idx]);
      });
    });

    function seleccion() {
      return Array.prototype.map.call(raiz.querySelectorAll('[data-sf-opcion]'), function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function filtrarColor(valor) {
      if (!cfg.opcionColor && cfg.opcionColor !== 0) return;
      var clave = (valor || '').toLowerCase();
      var hay = minis.some(function (m) { return (m.dataset.alt || '').toLowerCase().indexOf(clave) > -1; });
      minis.forEach(function (m) { m.hidden = hay && (m.dataset.alt || '').toLowerCase().indexOf(clave) === -1; });
      var v = visibles(); if (v.length) mostrar(v[0]);
    }
    function actualizar(cambioColor) {
      var sel = seleccion();
      raiz.querySelectorAll('[data-sf-opcion]').forEach(function (fs, i) {
        var lbl = fs.querySelector('legend span'); if (lbl) lbl.textContent = sel[i] || '';
      });
      var v = sel.length
        ? datos.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })
        : (datos.find(function (x) { return String(x.id) === String(inputId.value); }) || datos[0]);
      if (cambioColor && cfg.opcionColor !== null) filtrarColor(sel[cfg.opcionColor]);
      if (!v) { boton.disabled = true; textoBoton.textContent = cfg.noDisponible; return; }
      inputId.value = v.id;
      precioEl.textContent = dinero(v.price);
      var sv = document.querySelector('[data-sf-sticky-var]'), sp = document.querySelector('[data-sf-sticky-precio]');
      if (sv) sv.textContent = v.title; if (sp) sp.textContent = dinero(v.price);
      if (compEl) { compEl.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; }
      boton.disabled = !v.available;
      textoBoton.textContent = v.available ? cfg.agregar : cfg.agotado;
      raiz.querySelectorAll('[data-sf-oferta-precio]').forEach(function (el) {
        var n = parseInt(el.dataset.sfOfertaPrecio, 10), total = v.price * n;
        if (n === 3) total = v.price * 2;
        el.textContent = dinero(total);
      });
      if (window.history.replaceState && cfg.urlVariantes) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    raiz.querySelectorAll('[data-sf-opcion] input').forEach(function (inp, i) {
      inp.addEventListener('change', function () {
        var fs = inp.closest('[data-sf-opcion]');
        actualizar(parseInt(fs.dataset.sfOpcion, 10) === cfg.opcionColor);
      });
    });

    /* Ofertas: elegir 1, 2 o 3 piezas ajusta la cantidad */
    raiz.querySelectorAll('[data-sf-oferta] input').forEach(function (inp) {
      inp.addEventListener('change', function () { if (cant) cant.value = inp.value; avisoCantidad(); });
    });
    function avisoCantidad() {
      var n = parseInt(cant.value, 10) || 1;
      raiz.querySelectorAll('[data-sf-oferta] input').forEach(function (inp) { inp.checked = parseInt(inp.value, 10) === n; });
      var aviso = raiz.querySelector('[data-sf-aviso]');
      if (!aviso) return;
      aviso.innerHTML = n >= 3 ? cfg.aviso3 : (n === 2 ? cfg.aviso2 : cfg.aviso1);
    }
    raiz.querySelectorAll('[data-sf-mas]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, Math.min(30, (parseInt(cant.value, 10) || 1) + parseInt(b.dataset.sfMas, 10)));
        cant.value = n; avisoCantidad();
      });
    });
    if (cant) cant.addEventListener('change', avisoCantidad);

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (boton.disabled) return;
      var r = boton.getBoundingClientRect();
      boton.disabled = true; textoBoton.textContent = cfg.agregando;
      agregarAlCarrito([{ id: parseInt(inputId.value, 10), quantity: parseInt(cant.value, 10) || 1 }])
        .then(function (res) {
          confeti(r.left + r.width / 2, r.top + r.height / 2);
          if (abrirCarrito(res)) return;
          var item = res.items ? res.items[0] : res;
          return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (x) { return x.json(); })
            .then(function (carrito) { actualizarBurbuja(carrito.item_count); mostrarToast(item, carrito, cfg); });
        })
        .catch(function (err) { alert((err && (err.description || err.message)) || cfg.error); })
        .finally(function () { boton.disabled = false; textoBoton.textContent = cfg.agregar; });
    });

    actualizar(true);
    avisoCantidad();

    /* Botón fijo: aparece cuando el botón principal sale de la pantalla hacia arriba */
    var sticky = document.querySelector('[data-sf-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var sBtn = sticky.querySelector('[data-sf-sticky-btn]');
      new IntersectionObserver(function (en) {
        var e = en[0];
        var ver = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('sf-ver', ver);
        sticky.setAttribute('aria-hidden', ver ? 'false' : 'true');
        sBtn.tabIndex = ver ? 0 : -1;
      }).observe(boton);
      sBtn.addEventListener('click', function () {
        if (boton.disabled) { boton.scrollIntoView({ block: 'center', behavior: reducido ? 'auto' : 'smooth' }); return; }
        boton.click();
      });
    }
  }

  /* Botones con confeti al pulsar (decorativo) */
  function initBotonesConfeti() {
    document.querySelectorAll('[data-sf-confeti]').forEach(function (b) {
      b.addEventListener('mouseenter', function () {
        if (b._sfC) return; b._sfC = true;
        var r = b.getBoundingClientRect(); confeti(r.left + r.width / 2, r.top);
        setTimeout(function () { b._sfC = false; }, 2500);
      });
    });
  }

  /* Fechas estimadas de entrega (solo días hábiles) */
  function initEntrega() {
    document.querySelectorAll('[data-sf-entrega]').forEach(function (box) {
      /* Días de descanso obligatorio en México (Ley Federal del Trabajo) */
      var nLunes = function (y, m, n) { var d = new Date(y, m, 1); var off = (8 - d.getDay()) % 7; return 1 + off + (n - 1) * 7; };
      var feriado = function (d) {
        var y = d.getFullYear(), m = d.getMonth(), dia = d.getDate();
        if ((m === 0 && dia === 1) || (m === 4 && dia === 1) || (m === 8 && dia === 16) || (m === 11 && dia === 25)) return true;
        if (m === 1 && dia === nLunes(y, 1, 1)) return true;
        if (m === 2 && dia === nLunes(y, 2, 3)) return true;
        if (m === 10 && dia === nLunes(y, 10, 3)) return true;
        if (m === 9 && dia === 1 && (y - 2024) % 6 === 0) return true;
        return false;
      };
      var habil = function (d) { return d.getDay() !== 0 && d.getDay() !== 6 && !feriado(d); };
      var sumar = function (f, n) { var d = new Date(f); while (n > 0) { d.setDate(d.getDate() + 1); if (habil(d)) n--; } return d; };
      var txt = function (d) { return d.toLocaleDateString('es-MX', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, '').replace(' de ', ' '); };
      var hoy = new Date();
      var envio = sumar(hoy, parseInt(box.dataset.prep, 10) || 0);
      var min = sumar(envio, parseInt(box.dataset.min, 10) || 0);
      var max = sumar(envio, parseInt(box.dataset.max, 10) || 0);
      box.querySelector('[data-sf-fecha="hoy"]').textContent = txt(hoy);
      box.querySelector('[data-sf-fecha="envio"]').textContent = txt(envio);
      var corto = function (d) { return d.toLocaleDateString('es-MX', { weekday: 'short', day: 'numeric' }).replace(/\./g, ''); };
      box.querySelector('[data-sf-fecha="llega"]').textContent = +min === +max ? txt(max) : (min.getMonth() === max.getMonth() ? corto(min) : txt(min)) + ' – ' + txt(max);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCuenta(); initEntrega(); initSugerencias(); initArriba(); initPopup(); initReveal(); initGrajeas(); initFlotante(); initToast(); initProducto(); initBotonesConfeti();
  });
})();
